import { ShopRendererDraftApiClient } from '@fourthwall/services/dist/ShopRendererDraftApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useCustomPageLayoutQuery = createQueryHook(
  ShopRendererDraftApiClient.getLayoutCustomPage,
  {
    queryKey: ['customPageLayout'],
  },
)
